import { useEffect } from 'react';

import courseAPI from 'src/api/course';
import { CourseApiInfiniteResponse } from 'src/api/types/courseType';
import {
  getCoursePageLimitAndOffset,
  resetCourseInfinitePages,
  shouldStopCourseInfiniteFetch,
} from 'src/helpers/courseApiResponse';
import useSWRInfinite, { SWRInfiniteConfiguration } from 'swr/infinite';

type CoursePageParams = {
  pageIndex: number;
  limit: number;
  offset: number;
};

type UseCourseListingInfiniteOptions = {
  getPageUrl: (params: CoursePageParams) => string | null;
  resetDeps: ReadonlyArray<unknown>;
  swrConfig?: SWRInfiniteConfiguration;
};

export const useCourseListingInfinite = ({
  getPageUrl,
  resetDeps,
  swrConfig,
}: UseCourseListingInfiniteOptions): CourseApiInfiniteResponse => {
  const courseApiResponse = useSWRInfinite((pageIndex, previousPageData) => {
    if (shouldStopCourseInfiniteFetch(previousPageData, pageIndex)) return null;
    const { limit, offset } = getCoursePageLimitAndOffset(pageIndex);
    return getPageUrl({ pageIndex, limit, offset });
  }, courseAPI.fetchCourses, swrConfig);

  const { setSize, mutate } = courseApiResponse;

  useEffect(() => {
    resetCourseInfinitePages(setSize, mutate);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- resetDeps is the intentional dependency list from callers
  }, [...resetDeps, setSize, mutate]);

  return courseApiResponse;
};
